/* eslint-disable @typescript-eslint/consistent-type-assertions */

import { setup } from 'xstate';

import { type Context, type Event } from '../utils';
import { Actions } from './forgot-to-scan.machine.actions';
import { Actors } from './forgot-to-scan.machine.actors';
import { Guards } from './forgot-to-scan.machine.guards';

export const forgotToScanMachine = setup({
  types: { context: {} as Context, events: {} as Event },
  actions: Actions,
  guards: Guards,
  actors: Actors,
}).createMachine({
  context: {},
  initial: 'idle',
  states: {
    idle: {
      on: {
        SHOW_FORM: 'form',
        SUBMIT_FORM: 'submitting',
      },
    },
    form: {
      on: {
        GO_BACK: 'idle',
        SUBMIT_FORM: 'submitting',
      },
    },
    submitting: {
      invoke: {
        id: 'submitForm',
        src: 'submitForm',
        input: ({ event }) => {
          if (event.type !== 'SUBMIT_FORM') throw new Error('Invalid event');
          return event.params;
        },
        onDone: [
          {
            target: 'pointsIssued',
            guard: 'hasPointsBeenIssued',
          },
          {
            target: 'timeRestrictionError',
            guard: 'isTimeRestrictionError',
          },
          {
            target: 'receiptAlreadyClaimedError',
            guard: 'isReceiptAlreadyClaimedError',
          },
          {
            target: 'transactionNotFoundError',
            guard: 'isTransactionNotFoundError',
          },
          {
            target: 'unknownError',
          },
        ],
        onError: 'unknownError',
      },
    },
    pointsIssued: {
      on: {
        GO_BACK: 'idle',
      },
    },
    timeRestrictionError: {
      on: {
        GO_BACK: 'idle',
        SUBMIT_FORM: 'submitting',
      },
    },
    receiptAlreadyClaimedError: {
      on: {
        GO_BACK: 'idle',
        SUBMIT_FORM: 'submitting',
      },
    },
    transactionNotFoundError: {
      on: {
        GO_BACK: 'idle',
        SUBMIT_FORM: 'submitting',
      },
    },
    unknownError: {
      on: {
        GO_BACK: 'idle',
        SUBMIT_FORM: 'submitting',
      },
    },
  },
});
